import { Box, Container } from '@mui/material';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { useEffect, useState } from 'react';
import { theme } from './generals/theme';
import PagePart from './PagePart';
import Hero from './Hero';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


function Home() {
    const [currentSubPage, setCurrentSubPage] = useState('hero');

    const possibilities = ['hero', 'video', 'fotos', 'info'];

    useEffect(() => {
        window.addEventListener('scroll', () => {
            const subpagePositions = possibilities.map((subpage) => {
                const element = document.getElementById(subpage) as HTMLElement;
                return element.getBoundingClientRect().top;
            });

            const subpagePositionsAbsolute = subpagePositions.map((position) => Math.abs(position));

            const minPosition = Math.min(...subpagePositionsAbsolute);

            const minPositionIndex = subpagePositionsAbsolute.indexOf(minPosition);

            const subpage = possibilities[minPositionIndex];

            setCurrentSubPage(subpage);
        });
    }, []);

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '100vh',
                position: 'relative',
                backgroundColor: theme.palette.primary.dark,
                color: 'white',
                pb: { xs: 12, md: 24 },
            }}
        >
            <Hero />
            <Box
                sx={{
                    width: '100%',
                }}
            >
                <Container
                    maxWidth="md"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                        py: 4,
                        justifyContent: 'center',
                    }}
                >
                    <PagePart
                        text="Info"
                        image="/img/info.png"
                        contents={[
                            {
                                type: 'vertical',
                                contents: [
                                    '/arbeit3.pdf',
                                ],
                                isPdf: true,
                            },
                        ]}
                        isHighlighted={currentSubPage === 'info'}
                    />
                    <PagePart
                        text="Videos"
                        image="/img/video.png"
                        contents={[
                            {
                                type: 'horizontal',
                                contents: [
                                    'https://www.youtube.com/embed/_H56IbnYkdc?si=LG5x0-DUfz0R8Czl',
                                ],
                                isYoutube: true,
                            },
                            {
                                type: 'vertical',
                                contents: [
                                    'https://www.youtube.com/embed/YEqdfiISuc4?si=JylL3HnpZwtrpBOc',
                                    'https://www.youtube.com/embed/T_egEwpL8Gg?si=nuS3fOxaaXZy4qQX',
                                    'https://www.youtube.com/embed/s2mGCSwhibg?si=fo-B41BAIIYWpb7k',
                                    'https://www.youtube.com/embed/2yiP63lDc_c?si=JylL3HnpZwtr',
                                    'https://www.youtube.com/embed/J3cWAt9iTS8?si=JylL3HnpZwtr',
                                    'https://www.youtube.com/embed/Kk6HFhD9ZY0?si=JylL3HnpZwtr',
                                    'https://www.youtube.com/embed/RYVH28OoEJo?si=JylL3HnpZwtr',
                                    'https://www.youtube.com/embed/wvOlQIqVSXE?si=JylL3HnpZwtr',
                                ],
                                isYoutube: true,
                            },
                        ]}
                        isHighlighted={currentSubPage === 'video'}
                    />
                    <PagePart
                        text="Fotos"
                        image="/img/fotos.png"
                        isHighlighted={currentSubPage === 'fotos'}
                        contents={[
                            {
                                type: 'horizontal',
                                contents: [
                                    '/img/1.jpeg',
                                    '/img/5.jpeg',
                                    '/img/10.jpeg',
                                    '/img/11.jpeg',
                                    '/img/12.jpeg',
                                    '/img/15.jpeg',
                                    '/img/19.jpeg',
                                    '/img/21.jpeg',
                                    '/img/31.jpeg',
                                ],
                            },
                            {
                                type: 'vertical',
                                contents: [
                                    '/img/2.jpeg',
                                    '/img/3.jpeg',
                                    '/img/4.jpeg',
                                    '/img/6.jpeg',
                                    '/img/7.jpeg',
                                    '/img/8.jpeg',
                                    '/img/9.jpeg',
                                    '/img/13.jpeg',
                                    '/img/14.jpeg',
                                    '/img/16.jpeg',
                                    '/img/17.jpeg',
                                    '/img/18.jpeg',
                                    '/img/20.jpeg',
                                    '/img/22.jpeg',
                                    '/img/23.jpeg',
                                    '/img/24.jpeg',
                                    '/img/25.jpeg',
                                    '/img/26.jpeg',
                                    '/img/27.jpeg',
                                    '/img/28.jpeg',
                                    '/img/29.jpeg',
                                    '/img/30.jpeg',
                                ]
                            }
                        ]}
                        hasArrows={true}
                    />
                </Container>
            </Box>
            <img
                src="/img/frame_u.png"
                alt=""
                style={{
                    width: '100%',
                    height: 'auto',
                    position: 'absolute',
                    filter: 'brightness(1.5)',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 5,
                }}
            />
        </Box>
    );
}

export default Home;
